"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("./styles");
var Link = function (_a) {
    var linkVariant = _a.linkVariant, context = _a.context, children = _a.children, color = _a.color, href = _a.href, onClick = _a.onClick, css = _a.css, target = _a.target, rel = _a.rel, _b = _a.sx, sx = _b === void 0 ? {} : _b, style = _a.style, to = _a.to, className = _a.className, id = _a.id, component = _a.component, key = _a.key, underline = _a.underline, classes = _a.classes, variant = _a.variant, type = _a.type, passHref = _a.passHref, dataTestId = _a["data-testid"], ariaLabel = _a["aria-label"], ariaLabelledBy = _a["aria-labelledby"], ariaDescribedBy = _a["aria-describedby"], onMouseOver = _a.onMouseOver, onMouseLeave = _a.onMouseLeave, role = _a.role, tabIndex = _a.tabIndex, download = _a.download;
    var LinkComponent;
    switch (linkVariant) {
        case 'primary':
            LinkComponent = styles_1.PrimaryLink;
            break;
        case 'secondary':
            LinkComponent = styles_1.SecondaryLink;
            break;
        case 'name':
            LinkComponent = styles_1.TypographyNameLink;
            break;
        case 'dark':
            LinkComponent = styles_1.DarkBackgroundLink;
            break;
        default:
            LinkComponent = styles_1.PrimaryLink;
    }
    return (react_1.default.createElement(LinkComponent, { context: context, "data-testid": dataTestId, href: href, color: color, linkVariant: linkVariant, onClick: onClick, css: css, target: target, rel: rel, sx: sx, style: style, to: to, className: className, id: id, component: component, key: key, underline: underline, classes: classes, variant: variant, type: type, passHref: passHref, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-describedby": ariaDescribedBy, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave, role: role, tabIndex: tabIndex, download: download }, children));
};
exports.default = Link;
//# sourceMappingURL=index.js.map